module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-purple-de34dcf109b2d4891b686a0014b2d0f6.svg";